export class TrainingPathDto {
  id: number;
  imageUrl: string;
  fullImagePath: string;
  trainingPathTime: number;
  status: boolean;
  archived: boolean;
}
